import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

/**
 * The custom fields of the `project-delete` form (platform-catalog fork,
 * scaffolder/project-delete/template.yaml), a module of the `scaffolder`
 * plugin like `odooProjectFormModule`: each `FormFieldBlueprint` attaches to
 * the scaffolder's form fields, and its component is loaded lazily with
 * them.
 *
 * No validator: neither field blocks the form. The project may be missing
 * from the catalog (the inventory step decides), and the real deletion's
 * safeguards are the template's own `acceptDataLoss` and `confirmation`.
 */
const projectToDeleteField = FormFieldBlueprint.make({
  name: 'project-to-delete',
  params: {
    field: async () => {
      const { ProjectToDelete } = await import('./ProjectToDelete');
      return createFormField({
        name: 'ProjectToDelete',
        component: ProjectToDelete,
        schema: makeFieldSchema({
          output: z => z.string(),
          uiOptions: z => z.object({}),
        }),
      });
    },
  },
});

const deletionModePickerField = FormFieldBlueprint.make({
  name: 'deletion-mode-picker',
  params: {
    field: async () => {
      const { DeletionModePicker } = await import('./DeletionModePicker');
      return createFormField({
        name: 'DeletionModePicker',
        component: DeletionModePicker,
        schema: makeFieldSchema({
          output: z => z.boolean(),
          uiOptions: z => z.object({}),
        }),
      });
    },
  },
});

export default createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [projectToDeleteField, deletionModePickerField],
});
